
export default {
  name: 'BbBtnDropdown',
  props: {
    icon: {
      type: String,
      default: 'chevron-down',
    },
    menu: {
      type: Object,
      default: () => ({}),
    },
  },
};
